export default __webpack_public_path__ + "static/media/services_bgSmall.b75b1046.jpg";